
    import './styles.scoped.css';
    export default {
  "background": "awsui_background_hyvsj_ae7i0_93",
  "scrolling-background": "awsui_scrolling-background_hyvsj_ae7i0_96",
  "sticky-background": "awsui_sticky-background_hyvsj_ae7i0_102",
  "has-sticky-notifications": "awsui_has-sticky-notifications_hyvsj_ae7i0_110",
  "breadcrumbs": "awsui_breadcrumbs_hyvsj_ae7i0_123",
  "has-sticky-background": "awsui_has-sticky-background_hyvsj_ae7i0_133",
  "drawers-container": "awsui_drawers-container_hyvsj_ae7i0_145",
  "has-open-drawer": "awsui_has-open-drawer_hyvsj_ae7i0_156",
  "disable-body-scroll": "awsui_disable-body-scroll_hyvsj_ae7i0_180",
  "drawers-desktop-triggers-container": "awsui_drawers-desktop-triggers-container_hyvsj_ae7i0_185",
  "has-multiple-triggers": "awsui_has-multiple-triggers_hyvsj_ae7i0_204",
  "drawers-mobile-triggers-container": "awsui_drawers-mobile-triggers-container_hyvsj_ae7i0_214",
  "drawers-trigger-content": "awsui_drawers-trigger-content_hyvsj_ae7i0_218",
  "drawers-trigger-overflow": "awsui_drawers-trigger-overflow_hyvsj_ae7i0_232",
  "drawers-trigger": "awsui_drawers-trigger_hyvsj_ae7i0_218",
  "drawer": "awsui_drawer_hyvsj_ae7i0_145",
  "drawer-content-container": "awsui_drawer-content-container_hyvsj_ae7i0_262",
  "drawer-close-button": "awsui_drawer-close-button_hyvsj_ae7i0_271",
  "drawer-content": "awsui_drawer-content_hyvsj_ae7i0_262",
  "drawer-content-hidden": "awsui_drawer-content-hidden_hyvsj_ae7i0_279",
  "drawer-slider": "awsui_drawer-slider_hyvsj_ae7i0_282",
  "is-drawer-open": "awsui_is-drawer-open_hyvsj_ae7i0_289",
  "content": "awsui_content_hyvsj_ae7i0_314",
  "layout": "awsui_layout_hyvsj_ae7i0_335",
  "has-max-content-width": "awsui_has-max-content-width_hyvsj_ae7i0_418",
  "content-type-dashboard": "awsui_content-type-dashboard_hyvsj_ae7i0_433",
  "is-overlap-disabled": "awsui_is-overlap-disabled_hyvsj_ae7i0_450",
  "is-hide-mobile-toolbar": "awsui_is-hide-mobile-toolbar_hyvsj_ae7i0_453",
  "has-content-gap-left": "awsui_has-content-gap-left_hyvsj_ae7i0_485",
  "has-content-gap-right": "awsui_has-content-gap-right_hyvsj_ae7i0_488",
  "content-first-child-notifications": "awsui_content-first-child-notifications_hyvsj_ae7i0_498",
  "has-breadcrumbs": "awsui_has-breadcrumbs_hyvsj_ae7i0_501",
  "content-first-child-header": "awsui_content-first-child-header_hyvsj_ae7i0_504",
  "has-header": "awsui_has-header_hyvsj_ae7i0_504",
  "content-first-child-main": "awsui_content-first-child-main_hyvsj_ae7i0_525",
  "disable-content-paddings": "awsui_disable-content-paddings_hyvsj_ae7i0_525",
  "has-split-panel": "awsui_has-split-panel_hyvsj_ae7i0_568",
  "split-panel-position-bottom": "awsui_split-panel-position-bottom_hyvsj_ae7i0_568",
  "block-body-scroll": "awsui_block-body-scroll_hyvsj_ae7i0_584",
  "unfocusable": "awsui_unfocusable_hyvsj_ae7i0_589",
  "container": "awsui_container_hyvsj_ae7i0_599",
  "is-navigation-open": "awsui_is-navigation-open_hyvsj_ae7i0_624",
  "is-tools-open": "awsui_is-tools-open_hyvsj_ae7i0_627",
  "is-split-panel-open": "awsui_is-split-panel-open_hyvsj_ae7i0_627",
  "split-panel-position-side": "awsui_split-panel-position-side_hyvsj_ae7i0_627",
  "has-active-drawer": "awsui_has-active-drawer_hyvsj_ae7i0_627",
  "mobile-toolbar": "awsui_mobile-toolbar_hyvsj_ae7i0_636",
  "mobile-toolbar-nav": "awsui_mobile-toolbar-nav_hyvsj_ae7i0_652",
  "mobile-toolbar-breadcrumbs": "awsui_mobile-toolbar-breadcrumbs_hyvsj_ae7i0_656",
  "mobile-toolbar-tools": "awsui_mobile-toolbar-tools_hyvsj_ae7i0_660",
  "navigation-container": "awsui_navigation-container_hyvsj_ae7i0_669",
  "show-navigation": "awsui_show-navigation_hyvsj_ae7i0_713",
  "animating": "awsui_animating_hyvsj_ae7i0_735",
  "showButtons": "awsui_showButtons_hyvsj_ae7i0_1",
  "navigation": "awsui_navigation_hyvsj_ae7i0_669",
  "openNavigation": "awsui_openNavigation_hyvsj_ae7i0_1",
  "animated-content": "awsui_animated-content_hyvsj_ae7i0_797",
  "hide-navigation": "awsui_hide-navigation_hyvsj_ae7i0_806",
  "notifications": "awsui_notifications_hyvsj_ae7i0_816",
  "sticky-notifications": "awsui_sticky-notifications_hyvsj_ae7i0_822",
  "split-panel-bottom": "awsui_split-panel-bottom_hyvsj_ae7i0_839",
  "position-bottom": "awsui_position-bottom_hyvsj_ae7i0_886",
  "openSplitPanelBottom": "awsui_openSplitPanelBottom_hyvsj_ae7i0_1",
  "split-panel-side": "awsui_split-panel-side_hyvsj_ae7i0_915",
  "position-side": "awsui_position-side_hyvsj_ae7i0_928",
  "tools-container": "awsui_tools-container_hyvsj_ae7i0_947",
  "tools": "awsui_tools_hyvsj_ae7i0_947",
  "openTools": "awsui_openTools_hyvsj_ae7i0_1",
  "has-tools-form-persistence": "awsui_has-tools-form-persistence_hyvsj_ae7i0_1042",
  "hide-tools": "awsui_hide-tools_hyvsj_ae7i0_1052",
  "show-tools": "awsui_show-tools_hyvsj_ae7i0_1064",
  "has-tools-form": "awsui_has-tools-form_hyvsj_ae7i0_1042",
  "trigger-badge-wrapper": "awsui_trigger-badge-wrapper_hyvsj_ae7i0_1124",
  "trigger": "awsui_trigger_hyvsj_ae7i0_1124",
  "selected": "awsui_selected_hyvsj_ae7i0_1188",
  "badge": "awsui_badge_hyvsj_ae7i0_1208",
  "trigger-wrapper": "awsui_trigger-wrapper_hyvsj_ae7i0_1212",
  "dot": "awsui_dot_hyvsj_ae7i0_1218"
};
  